export default "__VITE_ASSET__zTctuTqG__"